import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_slider_tags, update_slider_tags } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './slidertagsform.css';

export const SliderTagsForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);

    const [sliderTags, setSliderTags] = useState({
        name: state ? state.name : "",
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });

    const handleChange = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.name === 'name' ? e.target.value.replace(/\s+/g, '').toLowerCase() : e.target.value });
        setSliderTags({ ...sliderTags, [e.target.name]: e.target.name === 'name' ? e.target.value.replace(/\s+/g, '').toLowerCase() : e.target.value });
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: sliderTags[e.target.name] ? false : true });
        setSliderTags({ ...sliderTags, [e.target.name]: sliderTags[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        }
        let createUpdateSliderTags;
        setIsLoading(true);
        if (state) {
            createUpdateSliderTags = await update_slider_tags(sliderTags, state._id)
        } else {
            createUpdateSliderTags = await add_slider_tags(sliderTags)
        }
        setIsLoading(false);
        if (createUpdateSliderTags) {
            const { message, status } = createUpdateSliderTags;
            if (status) {
                toast.success(message);
                navigate("/slidertags");
                setSliderTags({
                    name: "",
                    isActive: false,
                });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];

        // Object.keys(sliderTags).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (sliderTags[fieldName].toString().length > 0) {
        //             allFieldDone.push(true);
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateSliderTags;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateSliderTags = await update_slider_tags(sliderTags, state._id)
        //     } else {
        //         createUpdateSliderTags = await add_slider_tags(sliderTags)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateSliderTags) {
        //         const { message, status } = createUpdateSliderTags;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/slidertags");
        //             setSliderTags({
        //                 id: "",
        //                 name: "",
        //                 isActive: false,
        //             });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit SliderTags` : `Add SliderTags`}</h3>
            </div>
            <Row>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={12} className="mb-3">
                                <Row>
                                    <Form.Label htmlFor='sliderTags_name' column md={3} sm={4}>Name</Form.Label>
                                    <Col><Form.Control id='sliderTags_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : sliderTags.name} required /></Col>
                                </Row>
                            </Col>
                            {/* {
                                state && */}
                            <Col lg={12} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='sliderTags_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="sliderTags_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : sliderTags.isActive} role="button" /></Col>
                                </Row>
                            </Col>
                            {/* } */}
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Row className='align-items-center'>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

SliderTagsForm.defaultProps = {
    title: "SliderTags Form"
};

export default SliderTagsForm;